import api from "@/lib/api";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// Polls an async generation job until it is done or errors.
// statusPath e.g. "/tailoring/jobs" or "/screening/jobs".
// Generous default cap (~7 min) since some AI engines are slow on long generations.
export async function pollJob(jobId, statusPath, { interval = 3000, tries = 140 } = {}) {
  for (let i = 0; i < tries; i++) {
    await sleep(interval);
    const { data: status } = await api.get(`${statusPath}/${jobId}`);
    if (status.status === "done") return status;
    if (status.status === "error") throw new Error(status.detail || "Generation failed");
  }
  throw new Error("Generation is taking longer than expected. Please try again.");
}
